import React from "react";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { QuickActionsMenu } from "@/components/specialist/QuickActionsMenu";
import { OfflineIndicator } from "@/components/OfflineIndicator";
import { PWAInstallPrompt } from "@/components/PWAInstallPrompt";
import { useAuth } from "@/hooks/useAuth";

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { userRole } = useAuth();

  return (
    <div className="min-h-[100dvh] bg-background flex flex-col lg:flex-row w-full">
      <Sidebar />
      <div className="flex-1 flex flex-col w-full min-w-0">
        <Header />
        <OfflineIndicator />
        <main className="flex-1 p-3 sm:p-4 lg:p-6 overflow-auto touch-pan-y pb-20 lg:pb-6">
          {children}
        </main>
      </div>
      {userRole === "specialist" && (
        <>
          <QuickActionsMenu />
          <PWAInstallPrompt />
        </>
      )}
    </div>
  );
};